import React from 'react';
import { useState } from 'react';
import IngredientForm from './IngredientForm/IngredientForm';
import IngredientsList from './IngredientsList/IngredientsList';
import "./IngredientPage.css";
import { useData } from "../DataContext/DataProvider"

function IngredientPage() {
    const [searchInput, setSearchInput] = useState("");
        
    const dataContext = useData();
    
    let ingredients = dataContext.ingredientsData.ingredients?.filter((ingredient) => {
        return ingredient.Ingredient_Name.toLocaleUpperCase().includes(searchInput.toLocaleUpperCase())//make search case insensitive. *locale* upper case prevents weird stuff like turkish I, apparently
    });
 
    //only display list when server has been accessed, otherwise display error screen
    if (dataContext.ingredientsData.serverAccess === 1) {
        return (
            <div className="ingredient-page">
                <IngredientForm/>
                <div className="ingredient-lists-container">
                    <IngredientsList
                        ingredientsArray={ingredients}
                        handleSearch={setSearchInput}
                        searchValue={searchInput }
                    />
                </div>
            </div>
        );
    }
    else if (dataContext.ingredientsData.serverAccess === 0) {
        return (
            <div className="ingredient-page">
                <header className="ingredient-page-header hoverable-element">
                    <h3>
                        Please wait while we get your ingredients
                    </h3>
                </header>
            </div>
        );
    }
    else if (dataContext.ingredientsData.serverAccess === -1) {
        return (
            <div className="ingredient-page">
                <header className="ingredient-page-header hoverable-element">
                    <h3>
                        We've encountered an error accessing your ingredients, please wait a few minutes and then refresh
                    </h3>
                </header>
            </div>
        );
    }
}

export default IngredientPage;